import { parseIsoDate, toIsoDate } from '../rental-applications/listing-model';

/** Keep calendar selections as local ISO days, with inclusive date-only limits. */
export function dateSelectionValue(date: Date, min?: string, max?: string): string | null {
  if (!Number.isFinite(date.getTime())) return null;
  const value = toIsoDate(date);
  const earliest = parseIsoDate(min);
  const latest = parseIsoDate(max);
  if (earliest && value < toIsoDate(earliest)) return null;
  if (latest && value > toIsoDate(latest)) return null;
  return value;
}
